import { BrowserRouter, Routes, Route } from "react-router-dom";
import Footer from "./assets/components/Layout/Footer/Footer";
import Header from "./assets/components/Layout/Header/Header";

import MainPage from "./assets/components/Pages/MainPage";
import PrivacyPolicy from "./assets/components/Pages/PrivacyPolicy";
import { ScrollToTop } from "./assets/components/Layout/ScrollToTop";
import { ScrollToHash } from "./assets/components/Layout/ScrollToHash";

import DotGrid from "./assets/components/UI/DotGrid/DotGrid";

function App() {
  return (
    <BrowserRouter>
    <ScrollToTop />
    <ScrollToHash />
      <Header />
      <main>

      <div
          style={{
            width: "100%",
            // position: "absolute",
            position: "fixed",
            inset: "0",
            zIndex: "1",
            pointerEvents: "none",
          }}
        >
          <DotGrid
            dotSize={3}
            gap={15}
            // baseColor="#2e2e2f"
            baseColor="#282828"
            // activeColor="#12F7D6"
            activeColor="#98FAEC"
            proximity={120}
            shockRadius={250}
            shockStrength={5}
            resistance={750}
            returnDuration={1.5}
          />
        </div>


        <Routes>
          <Route path="/" element={<MainPage />}/>
          <Route path="/privacy-policy" element={<PrivacyPolicy />}/>
          <Route path="*" element={<h1>Страница не найдена</h1>} />
        </Routes>
      </main>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
